import { Glossary } from "../Glossary";
import { useScrollReveal } from "../../hooks/useScrollReveal";
import { useLanguage } from "../../context/LanguageContext";
import { useHome } from "../../translations/home";
import { DemoCTA } from "./DemoCTA";

const HomeSteps = () => {
  const { language } = useLanguage();
  const s = useHome(language).steps;
  const { ref, isRevealed } = useScrollReveal({ threshold: 0.2 });

  return (
    <section className="bg-white pt-20 pb-16 lg:pt-24 lg:pb-[7.5rem]" data-testid="steps-section">
      <Glossary><div className="wrap-cayus">
        <div className="rule-cobalt mb-5" />
        <p className="mono-cayus text-cobalt-600 mb-4">{s.eyebrow}</p>
        <h2 className="font-bold text-3xl sm:text-4xl text-inkc-800 tracking-[-0.03em] mb-12 max-w-[30ch]">{s.title}</h2>

        <div ref={ref} className={`grid md:grid-cols-3 gap-5 mb-12 stagger-grid ${isRevealed ? "is-in" : ""}`}>
          {s.items.map((item, i) => (
            <div key={i} className="card-lift bg-white border border-linec-200 rounded-xl p-7 lg:p-9" data-testid={`step-${i}`}>
              <span className="mono-cayus text-[#D97706] block mb-5">0{i + 1}</span>
              <h3 className="font-bold text-lg text-inkc-800 tracking-[-0.02em] mb-3">{item.t}</h3>
              <p className="text-[15px] text-inkc-600 leading-relaxed">{item.d}</p>
            </div>
          ))}
        </div>

        <p
          className="bg-navy-900 text-white text-lg sm:text-xl font-semibold rounded-xl px-7 py-6 mb-10 max-w-[52rem] mx-auto text-center"
          data-testid="steps-closing"
        >
          {s.closing}
        </p>

        <DemoCTA from="steps" variant="ghost" />
      </div></Glossary>
    </section>
  );
};

export default HomeSteps;
